import { DEMANDS, ComponentProps } from '@portalCommon/constants/';
import classnames from 'classnames/bind';
import { OptimizedImg } from '@commonPackage/components';
import { ModuleTitle } from '../../styles';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const Demand = ({ type, title }: ComponentProps) => {
  return (
    <div className={cx('demand-container')}>
      <ModuleTitle marginBottom={72} marginTop={36}>
        {title[0]}
        <span className={cx('highlight')}>{title[1]}</span>
      </ModuleTitle>
      <div className={cx('content')}>
        {DEMANDS[type].map(item => {
          return (
            <div className={cx('text-card')} key={item.icon}>
              <OptimizedImg src={item.icon} width={100} loading="lazy" />
              <div className={cx('title')}>{item.title}</div>
              <div className={cx('text')}>{item.text}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
